import React from "react";
import ReactTable from "react-table-v6";
import "react-table-v6/react-table.css";
import UserActions from "../../actions/UserActions";
import { RaisedButton, TextField } from "material-ui";
import UserEditorModal from "./user-editor-modal.jsx";
import { debounce } from "lodash";
import GodActions from "../../actions/GodActions.js";

const NEW_USER = "NEW";

export class NewUserTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      userIdBeingEdited: null,
      searchValue: "",
      sorted: [],
      page: -1
    };

    this.onSearchChange = this.onSearchChange.bind(this);
    this._onFetchData = this._onFetchData.bind(this);
    this._saveUser = this._saveUser.bind(this);
    this._become = this._become.bind(this);
    this._edit = this._edit.bind(this);
    this._delete = this._delete.bind(this);
    this._dismissUser = this._dismissUser.bind(this);
    this._fakeEventBucket = this._fakeEventBucket.bind(this);
  }

  debouncedOnFetchData = debounce(
    (page, sorted, searchValue) =>
      this.props.onFetchData(page, sorted, searchValue),
    250
  );

  onSearchChange(e) {
    this.setState({ searchValue: e.target.value });
    this.debouncedOnFetchData(
      this.state.page,
      this.state.sorted,
      e.target.value
    );
  }

  _onFetchData(state, instance) {
    this.props.onFetchData(state.page, state.sorted, this.state.searchValue);
    this.setState({ page: state.page, sorted: state.sorted });
  }

  _edit(id, e) {
    e.preventDefault();
    this.setState({ userIdBeingEdited: id });
  }

  _saveUser(user) {
    let id = this.state.userIdBeingEdited;

    if (id === NEW_USER) {
      UserActions.godCreateUser(user);
    } else {
      UserActions.godEditUser(id, user);
    }

    this._dismissUser();
  }

  _dismissUser() {
    this.setState({ userIdBeingEdited: null });
  }

  _fakeEventBucket({ name, timezone } = {}) {
    GodActions.createFakeEventBucket({
      user: this.state.userIdBeingEdited,
      name: name,
      timezone: timezone
    });
    this._dismissUser();
  }

  _delete(id, e) {
    e.preventDefault();

    if (
      window.confirm(
        `Are you sure you want to delete "${
          this.props.users.find(user => user.id === id).organization
        }"? There is NOOOO going back.`
      )
    ) {
      UserActions.godDeleteUser(id);
      this.setState(this.state);
    }
  }

  _become(id, e) {
    e.preventDefault();
    UserActions.setGodUser(id);
  }

  render() {
    const { users, pages, currentUser, loading } = this.props;

    const columns = [
      {
        Header: "Organization",
        accessor: "organization",
        minWidth: 300,
        Cell: props => (
          <div>
            {currentUser === props.original.id ? (
              "👤"
            ) : (
              <a
                href="#"
                style={{ textDecoration: "none", opacity: 0.25 }}
                onClick={this._become.bind(this, props.original.id)}
              >
                👤
              </a>
            )}
            &nbsp;
            {props.original.organization}&nbsp;
            <span style={{ fontSize: "0.75em", color: "#ccc" }}>
              {props.original.id}
            </span>
          </div>
        )
      },
      {
        id: "type",
        Header: "Type",
        accessor: user =>
          user.type === "festival_organizer"
            ? "Festival"
            : user.type === "content_creator"
            ? "Content Creator"
            : user.type
      },
      {
        id: "currency",
        Header: "Currency",
        accessor: user => (user.currency || "UNK").toUpperCase()
      },
      {
        id: "virtual_festival_plan",
        Header: "Virtual Status",
        accessor: user =>
          user.virtual_festival_plan_status
            ? `${user.virtual_festival_plan} – ${user.virtual_festival_plan_status}`
            : ``
      },
      {
        id: "fee_percent",
        Header: "Fee Percent",
        accessor: user => `${user.fee_percent}%`
      },
      {
        id: "is_demo",
        Header: "Status",
        accessor: user => (user.is_demo ? "Demo" : "Standard")
      },
      {
        Header: "Actions",
        sortable: false,
        Cell: props => (
          <div>
            <a href="#" onClick={this._edit.bind(this, props.original.id)}>
              Edit
            </a>
            {currentUser !== props.original.id && (
              <span>
                &nbsp;
                <a
                  href="#"
                  onClick={this._delete.bind(this, props.original.id)}
                >
                  Delete
                </a>
              </span>
            )}
          </div>
        )
      }
    ];

    return (
      <div>
        {this.state.userIdBeingEdited ? (
          <UserEditorModal
            isNew={this.state.userIdBeingEdited === NEW_USER}
            user={this.props.users.find(
              user => user.id === this.state.userIdBeingEdited
            )}
            roles={this.props.roles}
            onSave={this._saveUser}
            onCancel={this._dismissUser}
            onFakeEventBucket={this._fakeEventBucket}
          />
        ) : null}
        <TextField
          floatingLabelText="Search Organization"
          value={this.state.searchValue}
          onChange={this.onSearchChange}
        />
        <ReactTable
          columns={columns}
          data={users}
          loading={loading}
          manual
          pages={pages}
          pageSize={50}
          showPageSizeOptions={false}
          onFetchData={this._onFetchData}
          defaultSorted={[{ id: "organization", desc: false }]}
        />
        {!this.props.hideAddButton ? (
          <RaisedButton
            label="Add new organization"
            primary={true}
            style={{ marginTop: 10 }}
            onTouchTap={this._edit.bind(this, NEW_USER)}
          />
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/partials/new-user-table.jsx